import { AccountingOffice } from "types/AccountingOffice"
import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const accountingOfficeReducer: RemoteReducer<AccountingOffice> =
  createRemoteReducer("accountingOffice")
